import type {
    DraftSaveCalendarViewConfig,
    SaveCalendarViewConfig,
} from '../store/schema/SaveCalendarViewConfig';
import { getGuid } from 'owa-guid';
import { getCalendarEntries } from 'owa-calendar-cache';

/**
 * Creates a SaveCalendarViewConfig from an DraftSaveCalendarViewConfig.
 * Creates a unique ID for this object.
 */
export function createSaveCalendarViewConfig(
    draftSaveCalendarViewConfig: DraftSaveCalendarViewConfig
): SaveCalendarViewConfig {
    let newSaveCalendarViewConfig: SaveCalendarViewConfig = {
        id: getGuid(),
        ...draftSaveCalendarViewConfig,
    };
    return newSaveCalendarViewConfig;
}

export function removeInactiveCalendarIds(calendarIds: string[]) {
    let hasUpdated = false;
    let updatedCalendarIds: string[] = calendarIds;

    const allCalendarIds = getCalendarEntries().map(calendar => calendar.calendarId.id);

    const inactiveCalendars = calendarIds.filter(
        calendarId => !allCalendarIds.includes(calendarId)
    );
    if (inactiveCalendars?.length > 0) {
        hasUpdated = true;
        const activeCalendars = calendarIds.filter(
            calendarId => !inactiveCalendars.includes(calendarId)
        );
        updatedCalendarIds = activeCalendars;
    }
    return { hasUpdated: hasUpdated, updatedCalendarIds: updatedCalendarIds };
}
